import { Fragment, FunctionComponent, h } from 'preact';
import { useRef } from 'preact/hooks';

import { domClassMerge } from 'common/helper/dom/class-merge';
import { preactToChildArray } from 'common/helper/preact/to-child-array';
import { ButtonComponent } from 'common/module/button/component';
import { ButtonComponentTypeEnum } from 'common/module/button/component-type.enum';
import { ButtonTemplatePropsInterface } from 'common/module/button/template-props.interface';

import { SaveSearchCardPropsInterface } from './props.interface';

export const SaveSearchCardComponent: FunctionComponent<SaveSearchCardPropsInterface> = ({
  title,
  list = [],
  action,
  onClick,
  children,
  className,
}) => {
  const footerElem = useRef<HTMLDivElement>(null);

  const actions = preactToChildArray<ButtonTemplatePropsInterface>(action, (item) => item.type === ButtonComponent);

  return (
    <article
      className={domClassMerge('save-search-card', className, {
        'save-search-card--clickable': typeof onClick !== 'undefined',
      })}
      data-key='save-search-card'
      data-testid='save-search-card'
      onClick={(event: MouseEvent): void => {
        if (!footerElem?.current?.contains(event.target as Node) && onClick) {
          onClick();
        }
      }}
    >
      <div className='save-search-card__title-container'>
        <h3 className='save-search-card__title' data-key='save-search-card-title' data-testid='save-search-card-title'>
          {title}
        </h3>
      </div>

      {children && (
        <p className='save-search-card__body' data-key='save-search-card-body' data-testid='save-search-card-body'>
          {children}
        </p>
      )}
      {!!list.length && (
        <dl className='save-search-card__list' data-key='save-search-card-list' data-testid='save-search-card-list'>
          {list.map((item, index) => {
            return (
              <Fragment key={index}>
                <dt className='save-search-card__list-label'>{item.label}:&nbsp;</dt>
                <dd className='save-search-card__list-value'>{item.value}</dd>
              </Fragment>
            );
          })}
        </dl>
      )}
      {!!actions.length && (
        <footer
          ref={footerElem}
          className='save-search-card__actions'
          data-key='save-search-card-actions'
          data-testid='save-search-card-actions'
        >
          {actions.map((item) => {
            item.props.componentType = ButtonComponentTypeEnum.type1;
            item.props.cssClass = ['save-search-card__actions-button'].concat(item.props?.cssClass || []).join(' ');
            return item;
          })}
        </footer>
      )}
    </article>
  );
};
